<template>
  <figure class="focal-image" v-if="imageObject" @click="$emit('click')">
    <div v-if="overlay" class="overlay-image" :class="{'-bottom': overlayDirecton === 'bottom'}"></div>
    <SingleImage
      v-if="($mqAliases.xs || $mqAliases.sm) && imageObject && imageObject.FocalPointX > 0"
      :key="0"
      :isFocal="true"
      :imageObject="imageObject"
      :focalRatio="focalRatio"
      :alt="imageObject.AlternateText"
      :width="320"
      :height="imageObject.Height / imageObject.Width * 320"
      :maxWidth="imageObject.Width"
      :maxHeight="imageObject.Height"
      :photoSwipe="photoSwipe"
    ></SingleImage>
    <SingleImage
      v-else
      :key="1"
      :isFocal="false"
      :imageObject="imageObject"
      :alt="imageObject.AlternateText"
      :width="320"
      :height="imageObject.Height / imageObject.Width * 320"
      :maxWidth="imageObject.Width"
      :maxHeight="imageObject.Height"
      :photoSwipe="photoSwipe"
    ></SingleImage>
  </figure>
</template>
<script>
import SingleImage from '@/Scripts/components/media/Image/ImageContent.vue';
export default {
  name: 'FocalImage',
  components: {
    SingleImage
  },
  props: {
    imageObject: Object,
    index: Number,
    photoSwipe: Boolean,
    overlay: Boolean,
    /**
     * Ratio to use for mobile pictures
     */
    focalRatio: {
      type: Number,
      default: 0.75
    },

    overlayDirecton: {
      type: String,
      default: 'top'
    }
  }
};
</script>
<style lang="scss" src="@/scss/components/components.overlay-image.scss"></style>
<style lang="scss">
.focal-image {
  margin-bottom: 0;

  img {
    max-width: 100%;
  }
}
</style>
